import { circleStrikeTrough } from '../../../components/shared/vector-images';
import { toggleLayerIfRequired } from '../_helpers';

const layer = {
  displayName: 'Restricted areas',
  synonyms: '',
  group: 'mapboxLayer',
  typeUrl: 'restricted-area',
  icon: {
    baseShape: circleStrikeTrough,
    iconColor: '#fff',
    markerColor: '#E28D18',
  },
  shownByDefault: true,
  relativeDepth: 100,
  menuOptions: {
    visible: true,
    owningMenu: 'safety',
    order: 1000,
  },
};

layer.onInitialize = (/* map */) => {
  /* noop */
};

layer.onToggle = (map, show) => {
  toggleLayerIfRequired(map, 'restricted-area line', show);
  toggleLayerIfRequired(map, 'restricted-area fill', show);
  toggleLayerIfRequired(map, 'restricted-area symbol', show);
};

export default layer;
